import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { useLocation, useHistory } from 'react-router';
import Form from 'components/Form';
import FooterPanel from './FooterPanel';
import HeaderPanel from './HeaderPanel';
import inputs from './form.json';
import { logInUser, setLoggedStatus, showMessage, getSettingsData } from 'redux/actions';
import { getToken } from 'helpers';
import Spinner from 'components/Spinner';
import { ErrorOutline } from '@material-ui/icons';
import Alert from 'react-bootstrap/Alert';

const LoginPanel = ({ changeEv }) => {
    const dispatch = useDispatch();
    const location = useLocation();
    const history = useHistory();
    const [token, setToken] = useState(null);
    const { loading, user, isLogged, error } = useSelector((state) => state.sign);

    useEffect(() => {
        let { from } = location.state || { from: { pathname: '/' } };
        isLogged && history.replace(from);
    }, [isLogged, location, history]);

    useEffect(() => {
        dispatch(getSettingsData());

        if (token) {
            dispatch(setLoggedStatus());
            dispatch(
                showMessage({
                    textId: 'reLoginSuccess',
                    target: 'top',
                }),
            );
        } else {
            checkToken();
        }
    }, [token, dispatch]);

    const checkToken = async () => {
        const _token = await getToken();
        setToken(_token);
    };

    const handleSaveUserData = (data) => {
        return dispatch(logInUser(data));
    };

    return (
        <React.Fragment>
            <Form
                className="form-outline sign--form"
                type="login"
                inputs={inputs.login}
                data={user || []}
                title="Zaloguj się"
                handleSubmitEv={handleSaveUserData}
                submitTitle="Zaloguj"
                formHeader={<HeaderPanel>Zaloguj się do swojego konta</HeaderPanel>}
                formFooter={<FooterPanel changeEv={() => changeEv('forgotPassword')}>Przypomnienie hasła</FooterPanel>}
                formMessage={
                    error && (
                        <Alert variant="danger" className="alert__tiny">
                            <ErrorOutline />
                            <p dangerouslySetInnerHTML={{ __html: error.message }} />
                        </Alert>
                    )
                }
            />
            {loading && <Spinner position="absolute" bg="white" />}
        </React.Fragment>
    );
};

LoginPanel.propTypes = {
    changeEv: PropTypes.func.isRequired,
};

export default LoginPanel;
